import webApp from './webApp';
import analytics from './analytics';

const social = {};

social.sharePage = function( socialMedia, pageId = null ) {

  if ( !pageId ) {
    pageId = webApp.issueReader.currentPage.id;
  }

  const issue = webApp.issueReader.issue;
  const page = issue.pages.find( page => page.id == pageId );

  const issuePrice = ( issue.paid ) ? 'paid' : 'free';
  const issueTags = ( issue.tags ) ? issue.tags : [];
  const issueName = issue.name;

  if (socialMedia == 'facebook') {
    analytics.sendEvent( 'AsteikkoMag', 'Share', 'Facebook', undefined, issue.id, page.id, issuePrice, issueTags.join( ',' ) );
    window.open( "http://www.facebook.com/sharer.php?u="+encodeURIComponent(page.share_url)+"%23share&t="+encodeURIComponent(page.title +' - '+ issueName +' - '+ webApp.env.site_name)+"&src=sp", '_blank' );
  }
  else if (socialMedia == "twitter") {
    analytics.sendEvent( 'AsteikkoMag', 'Share', 'Twitter', undefined, issue.id, page.id, issuePrice, issueTags.join( ',' ) );
    window.open( "https://twitter.com/intent/tweet?source=tweetbutton&text="+encodeURIComponent(page.title +' - '+ issueName +' - '+ webApp.env.site_name)+"&url="+encodeURIComponent(page.share_url), '_blank' );
  }
  else if (socialMedia == "linkedin") {
    analytics.sendEvent( 'AsteikkoMag', 'Share', 'LinkedIn', undefined, issue.id, page.id, issuePrice, issueTags.join( ',' ) );
    window.open( "https://www.linkedin.com/shareArticle?mini=true&title="+ encodeURIComponent( ( page.title +' - '+ issueName +' - '+ webApp.env.site_name ).substr( 0, 200 ) ) + "&source=Asteikko%20Magazine&url="+ encodeURIComponent( page.share_url ), '_blank' );
  }
  else if (socialMedia == 'googleplus') {
    analytics.sendEvent( 'AsteikkoMag', 'Share', 'Google Plus', undefined, issue.id, page.id, issuePrice, issueTags.join( ',' ) );
    window.open( "https://plus.google.com/share?url="+ encodeURIComponent( page.share_url ), '_blank' );
  }
  else if (socialMedia == "email") {
    analytics.sendEvent( 'AsteikkoMag', 'Share', 'Email', undefined, issue.id, page.id, issuePrice, issueTags.join( ',' ) );
    window.location.href = "mailto:?subject=" + encodeURIComponent(page.title +' - '+ issueName +' - '+ webApp.env.site_name) + "&body=" + encodeURIComponent( page.share_url );
  }
  else {
    webApp.console.error( `The sharePage() socialMedia argument "${ socialMedia }" is not supported` );
  }
};

export default social;
